import React from 'react';
import { Field } from 'react-final-form';
import RequiredLabel from '../RequiredLabel/RequiredLabel';
import Logic from '../../Logic';

const ValidatedField = (props) => {
  // let logic = new Logic();
    return (
      <Field name={props.name}>
          {({ input, meta }) => (
            <div className={(meta.submitError || meta.error && meta.touched) ? 'form-group has-danger col-sm-'+props.cols : !meta.error && meta.touched ? 'form-group has-success col-sm-'+props.cols : 'form-group col-sm-'+props.cols}>
              {props.hidestar == 'true' ? <label style={{marginLeft:'20px'}}>{props.label}</label> : <RequiredLabel>{props.label}</RequiredLabel>}{(meta.submitError || meta.error && meta.touched) && <div className="invalid-feedback" style={{display:'block'}}>{meta.error ? meta.error : meta.submitError}</div>}
                <input 
                {...input} 
                {...props}
                className={(meta.submitError || meta.error && meta.touched) ? 'form-control is-invalid' : !meta.error && meta.touched && !meta.submitError ? 'form-control is-valid' : 'form-control'} placeholder={props.placeholder} autoComplete="off"/>
            </div>
          )}
      </Field>
    );
  };
  
  /*
  <div className="invalid-feedback" style={{visibility: meta.error && meta.touched ? 'visible' : 'hidden'}}>{meta.error}</div>
  */
  export default ValidatedField;
  